<template>
  <div class="TutorfileView">

    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>

    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">ID</btn>
        <btn class="m-btn--column" @click.native="switchV('tutor_id')" v-bind:class="{ 'active': tutor_id }">先生ID</btn>
        <btn class="m-btn--column" @click.native="switchV('user')" v-bind:class="{ 'active': user }">登録者</btn>
        <btn class="m-btn--column" @click.native="switchV('file_name')" v-bind:class="{ 'active': file_name }">ファイル名</btn>
        <btn class="m-btn--column" @click.native="switchV('file')" v-bind:class="{ 'active': file }">ファイル</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
      </div>
    </template>

    <div style="display: flex" class="TutorfileView_upload">
      <form class="upload_form" method="post" enctype="multipart/form-data" @submit.prevent="postTutorfile" @keypress.stop.prevent.13>
        <multiselect v-model="watch.file_name" :options="fileName" label="name" :show-labels="false" placeholder="ファイル名"></multiselect>
        <div class="box">
          <i class="fa fa-camera"></i>
          <input @change="selectedFile" type="file" id="file">
        </div>
        <btn type="submit" class="upload">アップロード</btn>
      </form>
    </div>

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <th-c style="text-align: center">検索</th-c>
          <template v-if="id"><td-c><input v-model="searchQuery.id" type="text"></td-c></template>
          <template v-if="tutor_id"><td-c><input v-model="searchQuery.tutor_id" type="text"></td-c></template>
          <template v-if="user"><td-c><input v-model="searchQuery.user" type="text"></td-c></template>
          <template v-if="file_name">
            <td-c class="select">
              <multiselect v-model="watchSearch.file_name" :options="fileName" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="file"><td-c></td-c></template>
          <template v-if="created_at"><td-c><input v-model="searchQuery.created_at" type="text"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <th-c style="text-align: center">除外</th-c>
          <template v-if="id"><td-c><input v-model="notSearchQuery.id" type="text"></td-c></template>
          <template v-if="tutor_id"><td-c><input v-model="notSearchQuery.tutor_id" type="text"></td-c></template>
          <template v-if="user"><td-c><input v-model="notSearchQuery.user" type="text"></td-c></template>
          <template v-if="file_name">
            <td-c class="select">
              <multiselect v-model="watchSearch.not_file_name" :options="fileName" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="file"><td-c></td-c></template>
          <template v-if="created_at"><td-c><input v-model="notSearchQuery.created_at" type="text"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c style="text-align: center">削除</th-c>
          <th-c style="text-align: center">編集</th-c>
          <template v-if="id"><th-c @click.native='sort("id")'>ID</th-c></template>
          <template v-if="tutor_id"><th-c @click.native='sort("tutor_id")'>Tutor ID</th-c></template>
          <template v-if="user"><th-c @click.native='sort("user")'>User</th-c></template>
          <template v-if="file_name"><th-c @click.native='sort("file_name")'>ファイル名</th-c></template>
          <template v-if="file"><th-c @click.native='sort("file")'>ファイル</th-c></template>
          <template v-if="created_at"><th-c @click.native='sort("created_at")'>作成日</th-c></template>
        </tr-c>

        <tr-c slot="tr-td" v-for="list in notFilteredTutorfiles" :key="list.id" class="tr_hover" v-bind:class="{ 'list-edit': list.id == edit_id.edit_id }">

          <template v-if="list.id == edit_id.edit_id">

            <td-c @click.native="cancelTutorfile(list)" class="del">戻る</td-c>
            <td-c @click.native="patchTutorfile(list)" class="del">更新</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="tutor_id"><td-c>{{list.tutor_id}}</td-c></template>
            <template v-if="user"><td-c>{{list.user.user}}</td-c></template>
            <template v-if="file_name">
              <td-c class="select">
                <multiselect v-model="watchPatch.file_name" :options="fileName" label="name" :show-labels="false" placeholder=""></multiselect>
              </td-c>
            </template>
            <template v-if="file">
              <td-c>
                <form class="update_form" enctype="multipart/form-data">
                  <input @change="patchSelectedFile" type="file" id="file">
                </form>
              </td-c>
            </template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>

          </template>

          <template v-if="list.id !== edit_id.edit_id">
            <td-c @click.native="deleteTutorfile(list)" class="del">削除</td-c>
            <td-c @click.native="edit(list)" class="del">編集</td-c>
            <template v-if="id"><a v-bind:href="linkTutorfile(list)" target="_blank" class="link">{{list.id}}</a></template>
            <template v-if="tutor_id"><a v-bind:href="linkTutorfile(list)" target="_blank" class="link">{{list.tutor_id}}</a></template>
            <template v-if="user"><a v-bind:href="linkTutorfile(list)" target="_blank" class="link">{{list.user.user}}</a></template>
            <template v-if="file_name">
              <a v-bind:href="linkTutorfile(list)" target="_blank" class="link" v-if="list.file_name === 0">未選択</a>
              <a v-bind:href="linkTutorfile(list)" target="_blank" class="link" v-if="list.file_name === 1">履歴書</a>
              <a v-bind:href="linkTutorfile(list)" target="_blank" class="link" v-if="list.file_name === 2">アンケート</a>
              <a v-bind:href="linkTutorfile(list)" target="_blank" class="link" v-if="list.file_name === 3">研修写真</a>
              <a v-bind:href="linkTutorfile(list)" target="_blank" class="link" v-if="list.file_name === 4">指導厳守事項</a>
            </template>
            <template v-if="file"><a v-bind:href="linkTutorfile(list)" target="_blank" class="link"></a></template>
            <template v-if="created_at"><a v-bind:href="linkTutorfile(list)" target="_blank" class="link">{{list.created_at.substring(0, 10)}}</a></template>
          </template>

        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/tutorfiles/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  max: config.LIMIT,
  url: url,
  pageName: 'tutorfile',
  pageNames: 'tutorfiles'
}

let _ = window._
export default {
  props: {
    tutor: Object
  },

  data () {
    return {
      edit_id: {
        edit_id: ''
      },
      column: false,
      asc: '',
      desc: '',
      sortState: '',
      searchType: '',

      id: true,
      tutor_id: false,
      user: false,
      file_name: true,
      file: true,
      created_at: true,

      // search params
      searchQuery: {
        id: '',
        tutor_id: '',
        user: '',
        file_name: '',
        created_at: ''
      },

      notSearchQuery: {
        id: '',
        tutor_id: '',
        user: '',
        file_name: '',
        created_at: ''
      },

      watchSearch: {
        file_name: '',
        not_file_name: ''
      },

      // post params
      tutorfile: {
        file_name: '',
        file: ''
      },

      watch: {
        file_name: ''
      },

      // patch params
      PatchTutorfile: {
        file_name: '',
        file: ''
      },

      watchPatch: {
        file_name: ''
      },

      fileName: [
        { name: '未選択', value: 0 },
        { name: '履歴書', value: 1 },
        { name: 'アンケート', value: 2 },
        { name: '研修写真', value: 3 },
        { name: '指導厳守事項', value: 4 }
      ]
    }
  },

  computed: {
    orderedTutorfiles () {
      if (this.sortState === '' || this.sortState === 'asc') {
        return _.orderBy(this.tutor.tutorfiles, this.asc)
      } else if (this.sortState === 'desc') {
        return _.orderBy(this.tutor.tutorfiles, this.desc).reverse()
      }
    },

    FilteredTutorfiles () {
      var self = this // function の中でthisが使えないのでselfに置き換え
      var key = Object.keys(this.searchQuery) // ["id", "tutor_id",・・・]
      // console.log(key)
      let isSearch = key.every((e) => {
        if (!self.searchQuery[e]) {
          return true // default (全てfalseの場合)
        } else {
          return false // search 何か入力されてたらsearch
        }
      })
      // console.log(isSearch)
      if (isSearch) {
        return self.tutor.tutorfiles // 全部返す
      }
      // isSearch じゃなければfilterする
      return self.tutor.tutorfiles.filter((el) => {
        let re = [] // 正規表現の配列
        for (var i = 0; i < key.length; i++) {
          re.push(new RegExp(self.searchQuery[key[i]]))
        }
        // console.log(re)

        let els = [] // 正規表現と入力された値をtest関数で比べて返ってきたtrue,falseの配列
        for (var t = 0; t < key.length; t++) {
          let column = key[t]
          let input = el[[column]]
          els.push(re[t].test(input))
        }
        // console.log(els)

        let flg = els.every((el) => {
          if (el) {
            return true
          } else {
            return false
          }
        })
        // console.log(flg)
        return flg
      })
    },

    notFilteredTutorfiles () {
      var self = this // function の中でthisが使えないのでselfに置き換え
      var key = Object.keys(this.notSearchQuery) // ["id", "tutor_id",・・・]
      // console.log(key)
      let isSearch = key.every((e) => {
        if (!self.notSearchQuery[e]) {
          return true // default (全てfalseの場合)
        } else {
          return false // search 何か入力されてたらsearch
        }
      })
      // console.log(isSearch)
      if (isSearch) {
        return self.FilteredTutorfiles // 全部返す FilteredContractsを返す
      }
      // isSearch じゃなければfilterする
      return self.FilteredTutorfiles.filter((el) => { // FilteredContractsにfilterをかける
        let re = [] // 正規表現の配列
        for (var i = 0; i < key.length; i++) {
          re.push(new RegExp(self.notSearchQuery[key[i]]))
        }
        // console.log(re)

        let els = [] // 正規表現と入力された値をtest関数で比べて返ってきたtrue,falseの配列
        for (var t = 0; t < key.length; t++) {
          let column = key[t]
          let input = el[[column]]
          els.push(re[t].test(input))
        }
        // console.log(els)

        let flg = els.every((el) => {
          if (el) {
            return true
          } else {
            return false
          }
        })
        // console.log(flg)
        return !flg // 反転
      })
    }
  },

  watch: {
    'watch.file_name': function (now, old) {
      if (now) {
        this.tutorfile.file_name = now.value
      } else {
        this.tutorfile.file_name = ''
      }
    },

    'watchSearch.file_name': function (now, old) {
      if (now) {
        this.searchQuery.file_name = now.value
      } else {
        this.searchQuery.file_name = ''
      }
    },

    'watchSearch.not_file_name': function (now, old) {
      if (now) {
        this.notSearchQuery.file_name = now.value
      } else {
        this.notSearchQuery.file_name = ''
      }
    },

    'watchPatch.file_name': function (now, old) {
      if (now) {
        this.PatchTutorfile.file_name = now.value
      } else {
        this.PatchTutorfile.file_name = ''
      }
    }
  },
  methods: {
    linkTutorfile (list) {
      let URL = config['production'].url
      if (process.env.NODE_ENV === 'development') {
        URL = 'http://localhost:8080'
      }
      let link = URL + '#/tutorfile/view/' + list.id
      return link
    },

    switchV (col) {
      this[col] = !this[col]
    },

    reset () {
      this.id = false
      this.tutor_id = false
      this.user = false
      this.file_name = false
      this.file = false
      this.created_at = false
    },

    all () {
      this.id = true
      this.tutor_id = true
      this.user = true
      this.file_name = true
      this.file = true
      this.created_at = true
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === 'desc') {
        this.sortState = 'asc'
        this.asc = header
      } else if (this.sortState === 'asc') {
        this.sortState = 'desc'
        this.desc = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    // searchTable (e) {
    //   this.$store.dispatch('SEARCH', {
    //     this: this,
    //     e: e,
    //     obj: obj
    //   })
    // },

    edit (list) {
      this.edit_id.edit_id = list.id
      this.watchPatch.file_name = this.fileName[list.file_name]
    },

    selectedFile (e) {
      e.preventDefault()
      let files = e.target.files
      this.tutorfile.file = files[0]
    },

    patchSelectedFile (e) {
      e.preventDefault()
      let files = e.target.files
      this.PatchTutorfile.file = files[0]
    },

    postTutorfile () {
      this.$store.dispatch('postTutorfile', {
        this: this,
        tutorfile: this.tutorfile
      })
    },

    deleteTutorfile (list) {
      this.$store.dispatch('deleteTutorfile', {
        this: this,
        list: list
      })
    },

    cancelTutorfile (list) {
      this.$store.dispatch('cancelTutorfile', {
        this: this,
        list: list,
        edit_id: this.edit_id
      })
    },

    patchTutorfile (list) {
      this.$store.dispatch('patchTutorfile', {
        this: this,
        list: list,
        edit_id: this.edit_id,
        tutorfile: this.PatchTutorfile
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.link {
  text-decoration: none;
  display: table-cell;
  vertical-align: middle;
  border-bottom: solid 1px #ccc;
  border-right: solid 1px #ccc;
  padding: .5rem;
}
.index-box {
  height: calc(100vh - 280px);
  overflow: scroll;
  margin-top: 10px;
}
.upload_form {
  width: 700px;
  display: flex;
  .input {
    border: solid 1px #ccc;
    width: 150px;
    height: 36px;
    padding: 10px;
  }
  .box {
    position: relative;
    .fa-camera {
      color: #ccc;
      font-size: 25px;
      padding: 7px;
      height: 36px;
      position: absolute;
      top: 0;
    }
    width: 100%;
    input[type="file"] {
      height: 36px;
      -webkit-appearance: none;
      appearance: none;
      border: solid 1px #ccc;
      width: 100%;
      cursor: pointer;
    }
    input[type="file"]::-webkit-file-upload-button {
      width: 36px;
      height: 36px;
      opacity: 0;
      -webkit-appearance: none;
      appearance: none;
    }
  }
}
.upload {
  border: solid 1px #37474F;
  height: 36px;
  min-width: 120px;
  text-align: center;
  padding-top: 8px;
  cursor: pointer;
  background: #37474F;
  color: #fff;
}
.update_form {
}
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  padding: 0;
  outline: 0;
  border: none;
}
.del {
  text-align: center;
  cursor: pointer;
  &:hover {
    background: black;
    color: white;
  }
}
</style>

<style lang="scss">
.TutorfileView {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    // margin: 1px;
  }
  .multiselect__tags-wrap {
    background: red;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 65%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>

<style lang="scss">
.TutorfileView_upload {
  .multiselect {
    min-height: 36px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    border-radius: 0;
    min-height: 36px;
    padding: 0px 40px 0 2px;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 36px;
  }
  .multiselect__select {
    height: 36px;
    &:before {
      top: 65%px;
    }
  }
  .multiselect__single {
    margin-top: 7px;
    margin-bottom: 7px;
  }
  .multiselect__placeholder {
    padding: 11px 3px;
    margin: 0;
    font-size: .85rem;
    color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// TutorfileView.vue?721da107